import React from 'react'

export const SkinAssessmentHeaderContext = React.createContext(null);